
export interface PostgreSqlUser {
    username: string;
    password: string;
}
